module.exports = __webpack_public_path__ + "static/media/transport1.817410f9.png";